export default "__VITE_ASSET__28b3b359__"